var _tspan;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRankSeven = function SvgRankSeven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 152
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rank-seven_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29763",
    transform: "translate(-24829 -17677)",
    style: {
      fill: "none"
    },
    d: "M0 0h100v152H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 471",
    transform: "translate(24829 17677)",
    style: {
      clipPath: "url(#rank-seven_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": 7,
    transform: "translate(-24829 -17709.5)",
    style: {
      stroke: "#fff",
      strokeWidth: 3,
      fontSize: 140,
      fontFamily: "Sarabun-Bold,Sarabun",
      fontWeight: 700,
      letterSpacing: "-.1em",
      fill: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 150
  }, "7")))));
};

export default SvgRankSeven;